import Product1 from "../img/Introduction/product4.png";
import Product2 from "../img/Introduction/product2.png";
import Product3 from "../img/Introduction/product3.png";

export const sliderItems = [
    {
        title: "CRM",
        heading: "Tiara Timesheet",
        section: ["Tiara Timesheet app helps to track tasks and effort (timesheet) spent by your company staff across projects.",
            "The AI edition helps create entries automatically from user prompts."],
        thumbnail: Product1,
    },
    {
        title: "TIPS",
        heading: "Tiara Integration Product Suite",
        section: ["TIPS is a cloud platform for integrating data across cloud apps like :",
            "NetSuite", "Zoho", "Salesforce", "QB Online etc."],
        thumbnail: Product3,
        url: "https://tiaraintegration.com/",
    },
    {
        title: "Centroid",
        heading: "Centroid Dealer Management",
        section: ["Franchisee with Dealer", "Secondary Sales & Stock Visibility", "Dynamic Reports"],
        thumbnail: Product2,
    },
];